//Svelte hooks
import { get } from 'svelte/store';
//Services
import { format } from 'svelte-i18n';
import { postReq } from '../services/http';
//Design system components
import { toast } from '@Shelly/shelly-design-system';

export const getBoostState = (device, settings, status) => {
	const calibrated = status?.thermostats?.[0]?.pos !== -1;

	let boostEnabled =
		settings?.[device.category.split('s_')[0] + 's']?.[device.channel]?.boost_minutes > 0 &&
		calibrated;
	let remaining_time = status?.[device.category.split('s_')[0] + 's']?.[device.channel]?.boost_minutes;
	let boosted = remaining_time > 0;
	let time = boosted ? remaining_time : undefined;
	let active = boostEnabled && boosted ? true : false;

	return boostEnabled
		? {
				type: 'trv_boost',
				icon: 'fa-solid fa-rocket',
				time,
				active,
				boosted,
				boostEnabled,
			}
		: {};
};

export const requestBoostTrvDevice = async (device, isBoosted: boolean) => {
	const res = await postReq(
		`/device/generic_command`,
		{
			id: device.id,
			command: `valve`,
			payload: JSON.stringify({
				id: device.channel,
				boost_enable: !isBoosted,
			}),
		},
		20000, //this is needed because trv sometimes responds very slowly
	);
	if (res.isok) {
		toast.open({
			type: 'success',
			title: !isBoosted
				? get(format)('boost_enabled', { default: 'Boost enabled' })
				: get(format)('boost_disabled', { default: 'Boost disabled' }),
		});
	} else {
		toast.open({
			type: 'danger',
			title: get(format)('error_global', { default: 'Something went wrong!' }),
		});
	}
};

//#region schedules
export const prepareScheduleData = (data = [], $scheduleStore) => {
	let output_data = [];
	let sun = '',
		time,
		days;

	if (!$scheduleStore.edit) {
		data.push($scheduleStore);
	} else {
		data.splice($scheduleStore.index, 1, $scheduleStore);
	}

	data.forEach((_rule) => {
		let temperature;
		if (typeof _rule.brightness !== 'undefined') {
			if (_rule.brightness.toString().includes(' ')) {
				_rule.brightness = _rule.brightness.split(' ')[0];
			}
			temperature =
				Number(_rule.brightness) < 10 ? `${Number(_rule.brightness)}` : _rule.brightness;

			if (Number(temperature) === $scheduleStore.min) {
				temperature = 'lo';
			}
			if (Number(temperature) === $scheduleStore.max) {
				temperature = 'hi';
			}
		} else if (typeof _rule.brightness === 'undefined' && typeof _rule.selection !== 'undefined') {
			if (_rule.selection === 'open') {
				temperature = 'hi';
			}
			if (_rule.selection === 'close') {
				temperature = 'lo';
			}
		}
		time = _rule.time.split(':').join('');
		days = _rule.days.join('');

		if (_rule.type === 'Sunset') {
			if (time.includes('-')) {
				sun = 'bss';
			} else {
				sun = 'ass';
			}
		} else if (_rule.type === 'Sunrise') {
			if (time.includes('-')) {
				sun = 'bsr';
			} else {
				sun = 'asr';
			}
		} else {
			sun = '';
		}

		time = time.replace('-', '');
		output_data = [...output_data, `${time}${sun}-${days}-${temperature}`];
	});

	return output_data.join(',');
};

export const getChartDataTrv = (device, settings, formatted_rules, min, max) => {
	const unit = settings?.thermostats[device.channel].target_t.units,
		current = settings?.thermostats[device.channel].target_t.value;
	const _data = {
		intervals: [],
		current: current,
		units: unit,
		type: 'no color',
		base: '',
		height: '20',
	};
	if (formatted_rules?.length > 0) {
		formatted_rules.forEach((rule) => {
			let temperature =
				typeof rule.brightness === 'undefined'
					? rule.selection
					: typeof rule.brightness !== 'number'
						? rule.brightness.split(' ')[0]
						: rule.brightness;
			if (temperature.toString().includes('hi')) temperature = max;
			if (temperature.toString().includes('lo')) temperature = min;
			if (rule.mode === 'Time') {
				_data.base = temperature;
				_data.intervals.push({
					control: { devices: device.id, type: device.mode },
					sensor: device.id,
					base: temperature,
					days: rule.days,
					time: [rule.time, '23:59'],
				});
			}
		});
		return _data;
	} else {
		return undefined;
	}
};

export const validateSchedules = (schedules) => {
	let validate = true;
	if (schedules.length > 1) {
		const _times = schedules.map((x) => x.split('-')[0]);
		const _days = schedules.map((x) => x.split('-')[1].split(''));
		let indexes = [];
		_times.forEach((time, i) => {
			const index = _times.indexOf(time);
			const lastIndex = _times.lastIndexOf(time);
			if (index !== i) indexes.push({ index, lastIndex });
		});
		indexes.forEach((i) => {
			// console.warn(_times[i.index]);
			if (
				_days[i.index].some((x) => _days[i.lastIndex].includes(x)) ||
				_days[i.lastIndex].some((x) => _days[i.index].includes(x))
			) {
				validate = false;
			}
		});
	}
	return validate;
};
//#endregion

export const formatTargetValue = (targetValue) => {
	if (typeof targetValue === 'string') return targetValue;

	return targetValue?.toFixed(1);
};
